import React, { createContext, useContext, useCallback } from 'react';

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const getPermissionsForModule = useCallback((moduleNames) => {
    let permissions = JSON.parse(sessionStorage.getItem('permissions'));
    let userType = JSON.parse(sessionStorage.getItem('user'))?.user_type;
    console.log('USER TYPE', userType);

    if (userType === 'SUPER_ADMIN') {
      console.log('USER TYPE inside su', userType);
      return {
        read: true,
        create: true,
        delete: true,
        update: true,
      };
    }

    let combinedPermissions = {
      read: false,
      create: false,
      delete: false,
      update: false,
    };

    let index = moduleNames.findIndex((moduleName) => moduleName === 'OTHERS');
    if (index > -1) {
      combinedPermissions.read = true;
    }

    moduleNames.forEach((moduleName) => {
      const modulePermissions = permissions?.find(
        (perm) => perm.module_name === moduleName
      );
      if (modulePermissions) {
        combinedPermissions = {
          read:
            combinedPermissions.read ||
            modulePermissions.permission_policy.read,
          create:
            combinedPermissions.create ||
            modulePermissions.permission_policy.create,
          delete:
            combinedPermissions.delete ||
            modulePermissions.permission_policy.delete,
          update:
            combinedPermissions.update ||
            modulePermissions.permission_policy.update,
        };
      }
    });

    // Showroom users should have read access to these modules for the customer verification flow
    const showroomAllowedModules = [
      'Customer',
      'Customer Order',
      'Saving Plan',
      'Customer Lockers',
      'Customer Ticket',
      'Customer Kyc',
      'Customer Saving Plans',
      'Customer Bank',
      'Maker Checkers',
    ];
    if (
      userType === 'SHOWROOM' &&
      moduleNames.some((m) => showroomAllowedModules.includes(m))
    ) {
      combinedPermissions.read = true;
    }

    return combinedPermissions;
  }, []);

  return (
    <PermissionsContext.Provider value={{ getPermissionsForModule }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  return useContext(PermissionsContext);
};
